import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import Fab from '../../../layouts/Fab';

export function FloatingNewThreadButton({ handleClick }) {
  return (
    <Fab>
      <button
        id="newThreadButton"
        className="grid h-full w-full grid-flow-col place-items-center items-center gap-2 rounded-full bg-indigo-300/70 hover:bg-indigo-300/90 dark:bg-indigo-800/90 dark:hover:bg-indigo-800 sm:py-2 sm:px-4 lg:hidden"
        onClick={handleClick}
      >
        <Icon icon="ph:plus-bold" />
        <div className="hidden font-medium sm:block">New</div>
      </button>
    </Fab>
  );
}

FloatingNewThreadButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
